<template>
  <div class="single-select">

    <div class="single-select-header" v-click-outside="hide" @click="toggle">
      <h5>
        {{
          category.original.translation[locale] ? category.original.translation[locale].name : category.original.translation['en'].name
        }}
      </h5>

      <span v-if="selected">{{ selectedDropdown }}</span>
      <span v-if="!selected">-</span>

      <svg v-if="role.content == 'editor'" class="arrow-drop" xmlns="http://www.w3.org/2000/svg" fill="none"
           viewBox="0 0 24 24"
           stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
      </svg>

      <div class="dropdown-help" v-if="role.content == 'editor'">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"
             v-b-popover.hover.top="category.original.translation[locale] ? category.original.translation[locale].description : category.original.translation['en'].description">
          <path fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                clip-rule="evenodd"/>
        </svg>
      </div>

    </div>
    <div class="list-group mt-1 p-absolute full-width" style="width: calc(100% - 30px)" v-show="opened">
      <a v-for="item in category.subCategory" :key="item.id" @click.stop.prevent="changeSelected(item)" href=""
         class="list-group-item list-group-item-action">
        {{
          item.original.translation[locale] ? item.original.translation[locale].name : item.original.translation['en'].name
        }}
      </a>
    </div>
  </div>
</template>


<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'ProjectDropdown',
  props: {
    category: {
      type: Object,
      default: function () {
        return {}
      }
    },
    role: {
      type: Object,
      default: function () {
        return {}
      }
    },
    project: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      opened: false
    }
  },
  methods: {
    toggle() {
      if (this.role.content == 'editor') {
        this.opened = !this.opened
      }
    },
    changeSelected(item) {
      this.$emit('updateSelected', {category: this.category, item: item})
      this.hide()
    },
    hide() {
      this.opened = false
    }
  },
  directives: {
    ClickOutside
  },
  computed: {
    locale: function () {
      return this.$i18n.locale
    },
    selected: function () {
      return this.category.subCategory.find((item) => {
        return this.category.name != '' ? item.id == this.category.name : false
      })
    },
    selectedDropdown: function () {
      return !this.selected ? '-' : (this.selected.original.translation[this.locale] ? this.selected.original.translation[this.locale].name : this.selected.original.translation['en'].name)
    }
  }
};
</script>